<details>
  <summary>
    <strong>Meta-informasjonskapsler for markedsføring.</strong> Hvis du har godtatt cookies for markedsføring
    på dette nettstedet brukes det informasjonskapsler fra Meta.
  </summary>

  <p>
    Hvis du har godtatt cookie for markedsføring bruker dette nettstedet <a
      target="_blank"
      href="https://developers.facebook.com/docs/meta-pixel"
      hreflang="en">Meta Pixel</a
    >, datakode fra Meta som bruker Metas informasjonskapsler.
    <a href="https://www.facebook.com/privacy/policies/cookies/" target="_blank" hreflang="en"
      >Besøk Facebooks side om informasjonskapsler for alt om Metas informasjonskapsler</a
    >.
  </p>

  <p>
    Dette hjelper oss å analysere Ishavskraft sin Meta og Facebook-relaterte markedsføring for å
    kunne tilpasse vår markedsføring og annonsering.
  </p>
</details>
